import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { BaseStyle, TabBar } from '@nhl/nhl-breakaway-ui';

import { HEADER_HEIGHT } from '~/core/utils';

export const Module = styled.section`
    background: ${({ theme }) => theme.Surface.primary};
    margin-bottom: 20px;
    position: relative;

    ${BaseStyle.Mixins.screenSizes.large} {
        margin-bottom: 0;
    }
`;

export const Header = styled.header`
    ${BaseStyle.Mixins.gaps.medium}
    background: ${({ theme }) => theme.Surface.primary};
    display: flex;
    flex-direction: column;
    position: sticky;
    top: ${HEADER_HEIGHT}px;
    z-index: 1;

    ${BaseStyle.Mixins.screenSizes.medium} {
        position: initial;
        top: initial;
        gap: 20px;
    }
`;

export const StyledTabBar = styled(TabBar)`
    width: calc(100vw - 32px);

    ${BaseStyle.Mixins.screenSizes.medium} {
        width: 100%;
    }
`;

export const TitleAndCategories = styled.div`
    display: flex;
    align-items: center;
`;

export const TitleHeader = styled.h4`
    display: flex;
    align-items: center;
    gap: 3px;

    && {
        ${BaseStyle.Mixins.fontStyles.ui['24b']}
    }
`;

export const TitleLink = styled(NavLink)`
    display: flex;
    align-items: center;
`;

export const TitleInfo = styled.div`
    flex: 1;
    text-align: right;
`;

export const RightArrow = styled(ChevronRightIcon)`
    height: 32px;
    width: 32px;

    position: relative;
    left: -4px;
`;

export const RequirementsLabel = styled.span`
    ${BaseStyle.Mixins.fontStyles.ui['14b']};
    margin-left: 10px;
`;
